import Vue from 'vue'
import Vuex, { StoreOptions, ActionContext } from 'vuex';

const module = {
  namespaced: true, // 지정을 해줘야 RootState와 따로 동작한다. 없으면, RootState 변경시 같이 변경
  state: {
    data: '',  //RootState와 똑같이 작성해도 된다.
    token: '',  //RootState와 똑같이 작성해도 된다.
    employee:  new Object(),
  },
  mutations: {
    /*
    setData(state, data) {
      state.data = data;
      localStorage.setItem('authData', JSON.stringify(state.data));
    },
    */
    setAuth(state, data){
      state.token = data;
      localStorage.setItem('token', JSON.stringify(state.token));
    },
    removeAuth(state){
      state.token = '';
      localStorage.removeItem('token');
    },
    logout(){
      localStorage.removeItem('token');
      localStorage.removeItem('currentEmployee');
      $.removeCookie('token');
    },
    setEmployee(state, employee){
      state.employee = employee;
      localStorage.setItem('currentEmployee', JSON.stringify(state.employee));
    },
    removeEmployee(state){
      state.employee = null;
      localStorage.removeItem('currentEmployee');
    },
  },
  actions: {
    setAuth ({commit, dispatch}, data) {
      commit('setAuth', data);
      dispatch('validation');
    },
    removeAuth ({commit}) {
      commit('removeAuth');
    },
    setEmployee({commit}, employee) {
      commit('setEmployee', employee);
    },
    removeEmployee({commit}) {
      commit('removeEmployee');
    },
    logout ({commit}) {
      commit('logout');
    },
    validation({commit}){
      return Vue.prototype.$http
        .post('/api/public/emp/auth', null, {
          headers: {'X-AUTH-TOKEN' : this.state.token}
        })
        .then((result) => {
          commit("setEmployee", result.data);
          return true;
        }).catch((e) =>{
          commit("logout");
          return false;
        })
    }
  },
  getters: {
    data: function(state){

      state.token = JSON.parse(localStorage.getItem('token') || null);
      return state.token;
    },
    employee: function(state){

      state.employee = JSON.parse(localStorage.getItem('currentEmployee'));
      return state.employee;
    }
  }
}
export default module;
